import { toast } from "sonner";

export function welcomeToast(user) {
  const first = (user?.name || "").trim().split(/\s+/)[0];
  if (user?.needs_role) toast.success(`¡Te damos la bienvenida a VIVOTaller${first ? `, ${first}` : ""}!`);
  else if (user?.can_switch_role) {
    const alumno = user.role === "customer";
    toast.success(`¡Hola de nuevo${first ? `, ${first}` : ""}!`, {
      description: alumno
        ? "Entraste en tu perfil alumno, como la última vez. Para volver, usa \"Perfil Maestro\" en el menú."
        : "Entraste en tu perfil Maestro. Puedes pasar a \"Mi perfil alumno\" desde el menú.",
    });
  } else toast.success(`¡Hola de nuevo${first ? `, ${first}` : ""}!`);
}
